'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _antd = require('@adparlor-devops/antd');

var _escapeRegExp = require('lodash/escapeRegExp');

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);

var _ProgressUploadFile = require('./ProgressUploadFile');

var _ProgressUploadFile2 = _interopRequireDefault(_ProgressUploadFile);

var _components = require('../../../components');

var _index = require('../../../constants/index');

var _generic = require('../../../helpers/generic');

require('./Progress.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = _antd.Input.Search;
var Option = _antd.Select.Option;
var Progress = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Progress, _Component);

  function Progress() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Progress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Progress.__proto__ || (0, _getPrototypeOf2.default)(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchValue: ''
    }, _this.handleDateChange = function (dateRange) {
      if (_this.props.getExportList) {
        _this.props.getExportList({ dateRange: dateRange });
      }
    }, _this.buildColumns = function () {
      var admin = _this.props.location.query.admin;
      var paletteApiUrl = _this.props.paletteApiUrl;


      var columns = [{
        title: 'Blueprint Name',
        dataIndex: 'blueprintName',
        sorter: function sorter(objectOne, objectTwo) {
          return (0, _generic.sortTableAlphabetically)(objectOne, objectTwo, 'blueprintName');
        },
        render: function render(blueprintName, record) {
          var iconType = "";

          if (record.status === 'QUEUED') iconType = 'clock-circle-o';else if (record.status === 'IN_PROGRESS') iconType = 'loading';else if (record.status === 'COMPLETED') iconType = 'check-circle';else if (record.status === 'FAILED') iconType = 'close-circle-o';

          return _react2.default.createElement(
            'span',
            { className: 'blueprint-name' },
            _react2.default.createElement(_antd.Icon, { type: iconType }),
            ' ',
            blueprintName
          );
        }
      }, {
        title: 'Progress',
        dataIndex: 'status',
        sorter: function sorter(objectOne, objectTwo) {
          return (0, _generic.sortTableAlphabetically)(objectOne, objectTwo, 'status');
        },
        render: function render(status) {
          switch (status) {
            case 'COMPLETED':
              return 'Completed';
            case 'IN_PROGRESS':
              return 'In-Progress';
            case 'QUEUED':
              return 'Queued';
            case 'FAILED':
              return 'Failed';
            default:
              return 'Unknown';
          }
        }
      }, {
        title: 'Creator',
        dataIndex: 'userName',
        sorter: function sorter(objectOne, objectTwo) {
          return (0, _generic.sortTableAlphabetically)(objectOne, objectTwo, 'userName');
        }
      }, {
        title: 'Date Created',
        dataIndex: 'created_at',
        sorter: function sorter(objectOne, objectTwo) {
          return (0, _generic.sortTableByDate)(objectOne.created_at, objectTwo.created_at);
        },
        sortOrder: 'descend',
        render: function render(createdAt) {
          return (0, _generic.formatDateToHumanReadable)(createdAt);
        }
      }];

      if (admin) {
        columns.push({
          title: 'JSON Feed',
          dataIndex: 'id',
          render: function render(id) {
            return _react2.default.createElement(
              _reactCopyToClipboard2.default,
              { text: paletteApiUrl + '/export-jobs/' + id + '/json-feed' },
              _react2.default.createElement(
                'a',
                null,
                'Copy To Clipboard'
              )
            );
          }
        });
      }

      columns.push({
        title: 'CSV Download',
        dataIndex: 'csvLink',
        render: function render(csvLink) {
          return _react2.default.createElement(
            'div',
            { className: 'link-download' },
            _react2.default.createElement(
              'a',
              { className: csvLink ? null : 'disabled', href: csvLink },
              ' ',
              _react2.default.createElement(_antd.Icon, { type: 'file-text' }),
              ' Download CSV'
            )
          );
        }
      }, {
        title: 'Download Assets',
        dataIndex: 'assetLink',
        className: 'asset-link',
        render: function render(assetLink, record) {
          var admin = _this.props.location.query.admin;

          if (admin === 'true') {
            return _react2.default.createElement(_ProgressUploadFile2.default, {
              record: record
            });
          }
          return _react2.default.createElement(
            'div',
            { className: 'link-download' },
            _react2.default.createElement(
              'a',
              { className: assetLink ? null : 'disabled', href: assetLink },
              _react2.default.createElement(_antd.Icon, { type: 'file-text' }),
              ' Download Asset'
            )
          );
        }
      });

      return columns;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Progress, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          exportData = _props.exportData;
      var searchValue = this.state.searchValue;

      var dataSource = exportData.map(function (data) {
        return (0, _assign2.default)({}, data);
      });
      if (searchValue) {
        var reg = new RegExp((0, _escapeRegExp2.default)(searchValue), 'gi');
        dataSource = dataSource.map(function (record) {
          return record.blueprintName.match(reg) || record.userName.match(reg) ? record : null;
        }).filter(function (record) {
          return !!record;
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'Progress__Component' },
        _react2.default.createElement(
          _components.Header,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/creative_at_scale' },
            _react2.default.createElement(_antd.Icon, { type: 'rollback' })
          ),
          'Blueprint Export Progress'
        ),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'blueprint-filter-bar' },
            _react2.default.createElement(Search, {
              disabled: loading,
              placeholder: 'Search Events',
              onChange: function onChange(e) {
                return _this2.setState({ searchValue: e.target.value });
              },
              style: { width: 200 }
            }),
            _react2.default.createElement(
              _antd.Select,
              {
                disabled: loading,
                style: { width: 150 },
                defaultValue: _index.DATA_RANGE.find(function (range) {
                  return range.default;
                }).value,
                onChange: this.handleDateChange
              },
              _index.DATA_RANGE.map(function (range) {
                return _react2.default.createElement(
                  Option,
                  { key: range.value, value: range.value },
                  range.label
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'export-table' },
            _react2.default.createElement(_antd.Table, {
              rowKey: 'id',
              loading: loading,
              columns: this.buildColumns(),
              dataSource: dataSource,
              pagination: false
            })
          )
        )
      );
    }
  }]);
  return Progress;
}(_react.Component), _class.propTypes = {
  loading: _propTypes2.default.bool.isRequired,
  getExportList: _propTypes2.default.func.isRequired,
  exportData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number,
    blueprintId: _propTypes2.default.number,
    blueprintName: _propTypes2.default.string,
    csvLink: _propTypes2.default.string,
    status: _propTypes2.default.string,
    createdAt: _propTypes2.default.string,
    userName: _propTypes2.default.string
  })).isRequired,
  paletteApiUrl: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.shape({
      admin: _propTypes2.default.string
    })
  }).isRequired
}, _class.defaultProps = {
  WSSEToken: ''
}, _temp2);
exports.default = Progress;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/modules/Progress/components/Progress.js
// module id = 3938
// module chunks = 7